<template>
  <div class="page">
    <sui-segment class="content" padded attached emphasis="secondary">
      <sui-container>
        <h2 class="ui header">
          <i class="cog grey icon" />
          <sui-header-content>Settings</sui-header-content>
        </h2>
        <sui-menu class="big" attached="top" color="blue" :widths="visibleSections.length">
          <router-link class="item" :class="{active: $route.path === section.path, disabled: section.disabled}" :to="section.path" v-for="section in visibleSections" :key="section.path">
            <i class="icon" :class="section.icon" />{{section.text}}
          </router-link>
        </sui-menu>
        <router-view />
      </sui-container>
    </sui-segment>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'SettingsView',
    computed: {
      ...mapGetters(['access', 'config']),
      sections() {
        return [
          { path: '/settings/general', icon: 'columns', text: 'General' },
          //{ path: '/settings/plans', icon: 'money check alternate', text: 'Plans' },
          //{ path: '/settings/payments', icon: 'receipt', text: 'Payments', disabled: !this.access.tariffManagement },
          { path: '/settings/security', icon: 'shield', text: 'Security' },
        ]
      },
      visibleSections() {
        return this.sections.filter(section => !section.hidden)
      },
    },
  }
</script>

<style scoped>
  .page { display: flex; flex-direction: column; }
  .header { display: flex; align-items: center; justify-content: space-between; }
  .content { flex: 1; }
  .menu .item .icon { margin: 0 .3em 0 0!important; }
</style>
